(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/bet-summary/assets/javascripts/bet-summary-item.js') >= 0) return;  svs.modules.push('/components/racing/bet-summary/assets/javascripts/bet-summary-item.js');

'use strict';

const ButtonBet = svs.components.ReactButtonBet;
const BetSummaryItem = _ref => {
  let {
    value,
    isReserve,
    isPixChoice
  } = _ref;
  return React.createElement("div", {
    className: "bet-summary-item"
  }, isReserve && React.createElement("div", {
    className: "bet-summary-item-label reserve"
  }, "Res"), React.createElement(ButtonBet, {
    animated: true,
    branding: "racing",
    className: "coupon-btn-bet-racing summary-bet-racing ".concat(isReserve ? 'reserve' : '', " ").concat(isPixChoice ? 'pix-pick' : '', " "),
    label: value === undefined ? '' : value.toString(),
    selected: value !== undefined && value !== '',
    type: "button"
  }));
};
svs.racing.betSummary.BetSummaryItem = BetSummaryItem;

 })(window);